import React, { useRef, useState } from "react";
import { useIntl } from "react-intl";
import {
  CircularProgress,
  FormControl,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import StopIcon from "@material-ui/icons/Stop";
import Button from "@material-ui/core/Button";
import useStyles from "./PreviewSpeakerCard.style";
import { messages } from "./PreviewSpeakerCard.messages";
import { PreviewPublisherHook } from "../../../SessionVideo/hooks/usePreviewPublisher";
import testSound from "../../../../Assets/Audios/birds.mp3";

interface Props {
  preview: PreviewPublisherHook;
}

const PreviewSpeakerCard = (props: Props) => {
  const intl = useIntl();
  const classes = useStyles();
  const { preview } = props;
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(testSound));

  const playSound = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play().then(() => {
        setIsPlaying(true);
      });
    }
  };

  return (
    <Paper className={classes.paper}>
      <Grid container justify="center" alignItems="center">
        <Grid item md={4} xs={12}>
          <div className={classes.speakerPreviewContainer}>
            <div className={classes.speakerPreview}>
              <VolumeUpIcon className={classes.icon} />
              {isPlaying && (
                <CircularProgress
                  size={100}
                  thickness={3}
                  value={preview.audioLogLevel}
                  color="primary"
                  className={classes.progress}
                />
              )}
            </div>
          </div>
        </Grid>
        <Grid item md={8} xs={12}>
          <Typography variant="h5">
            {intl.formatMessage(messages.titleLabel)}
          </Typography>
          <Typography variant="body1">
            {intl.formatMessage(messages.content)}
          </Typography>
          <FormControl className={classes.formControl}>
            <Button
              variant="contained"
              color="primary"
              startIcon={isPlaying ? <StopIcon /> : <PlayArrowIcon />}
              size="small"
              onClick={() => playSound()}
            >
              {intl.formatMessage(
                isPlaying ? messages.stopButtonLabel : messages.playButtonLabel
              )}
            </Button>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PreviewSpeakerCard;
